import { render, staticRenderFns } from "./SpecialNode.vue?vue&type=template&id=c4384f52&"
import script from "./SpecialNode.vue?vue&type=script&lang=ts&"
export * from "./SpecialNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductLister: require('/home/vsts/work/1/a/NuxtApp/components/product/lister/index.vue').default})
